import clsx from "clsx";
import React from "react";
import * as PropTypes from "prop-types";

export const PlanChoice = ({plan, onSelected, isSelected}) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-4" style={{width: '30%'}}>
      {plan.centerBanner &&
        <p className="absolute-top-center-text center-banner-text fw-bold text-center p-0">
          {plan.centerBanner}
        </p>
      }
      <div className={`plan-choice-container d-flex flex-column justify-content-center align-items-center ${isSelected ? "selected-plan-choice" : ""}`} onClick={() => onSelected(plan)}>
        <div className={clsx("plan-choice-text text-center fw-bold", isSelected ? 'text-white' : 'text-black')}>
          {plan.displayName}
        </div>

        <div>
          <span className={clsx("plan-choice-text fw-bolder text-center", isSelected ? 'text-white' : 'text-black')}>{`$${plan.price}/${plan.frequencyType}`}</span>
        </div>


        {plan.tagLine1 &&
          <div className="d-flex absolute-top-right">
            <img alt="star" src="/img/buyNow/shapa-scale/star.svg" className="img-fluid price-star" />
            <p className="absolute-center plan-choice-sub-text fw-bold p-0">{plan.tagLine1}</p>
          </div>
        }
      </div>
    </div>
  );
};

PlanChoice.propTypes = {
  plan: PropTypes.object.isRequired,
  onSelected: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired
};
